import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiComponent } from './api.component';
import { PipesModule } from '../../../pipes/pipes.module';



@NgModule({
  declarations: [
    ApiComponent
  ],
  imports: [
    CommonModule,
    PipesModule
  ],
  exports: [
    ApiComponent
  ]
})
export class ApiModule { }
